
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("7YfZX"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("7YfZX", function(module, exports) {

let $5cda8bf0e1c6ef68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5cda8bf0e1c6ef68$var$load("cRtGo"),
    $5cda8bf0e1c6ef68$var$load("s4822"),
    $5cda8bf0e1c6ef68$var$load("3q2Ng"),
    $5cda8bf0e1c6ef68$var$load("jRpDi"),
    $5cda8bf0e1c6ef68$var$load("iXxzp"),
    $5cda8bf0e1c6ef68$var$load("dYtBN"),
    $5cda8bf0e1c6ef68$var$load("kNV5Y"),
    $5cda8bf0e1c6ef68$var$load("jUBhK"),
    $5cda8bf0e1c6ef68$var$load("ddJJa"),
    $5cda8bf0e1c6ef68$var$load("27glK"),
    $5cda8bf0e1c6ef68$var$load("bvY53"),
    $5cda8bf0e1c6ef68$var$load("f6ci5"),
    $5cda8bf0e1c6ef68$var$load("7jSfd"),
    $5cda8bf0e1c6ef68$var$load("4HZlX"),
    $5cda8bf0e1c6ef68$var$load("kDqHr"),
    $5cda8bf0e1c6ef68$var$load("gT8XU"),
    $5cda8bf0e1c6ef68$var$load("3GuOt"),
    $5cda8bf0e1c6ef68$var$load("3Mspc"),
    $5cda8bf0e1c6ef68$var$load("9aQIt"),
    $5cda8bf0e1c6ef68$var$load("XZauT"),
    $5cda8bf0e1c6ef68$var$load("4S1SF"),
    $5cda8bf0e1c6ef68$var$load("lm9Lt"),
    $5cda8bf0e1c6ef68$var$load("9wPDc"),
    $5cda8bf0e1c6ef68$var$load("1MWOL"),
    $5cda8bf0e1c6ef68$var$load("6fQco"),
    $5cda8bf0e1c6ef68$var$load("aOY32"),
    $5cda8bf0e1c6ef68$var$load("3MYQs"),
    $5cda8bf0e1c6ef68$var$load("6SWFK"),
    $5cda8bf0e1c6ef68$var$load("5zapo"),
    $5cda8bf0e1c6ef68$var$load("jiFtb"),
    $5cda8bf0e1c6ef68$var$load("6wr18"),
    $5cda8bf0e1c6ef68$var$load("9atVd"),
    $5cda8bf0e1c6ef68$var$load("dek7I"),
    $5cda8bf0e1c6ef68$var$load("6iz6l"),
    $5cda8bf0e1c6ef68$var$load("4SCW2"),
    $5cda8bf0e1c6ef68$var$load("fdKpi"),
    $5cda8bf0e1c6ef68$var$load("ffEVr"),
    $5cda8bf0e1c6ef68$var$load("hhss7"),
    $5cda8bf0e1c6ef68$var$load("eTYdV"),
    $5cda8bf0e1c6ef68$var$load("Wowvf"),
    $5cda8bf0e1c6ef68$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("cEcez"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("cEcez", function(module, exports) {

let $9352b5e7ba09e57b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9352b5e7ba09e57b$var$load("cRtGo"),
    $9352b5e7ba09e57b$var$load("s4822"),
    $9352b5e7ba09e57b$var$load("6wr18"),
    $9352b5e7ba09e57b$var$load("2tIxk"),
    $9352b5e7ba09e57b$var$load("dLq4a"),
    $9352b5e7ba09e57b$var$load("27glK"),
    $9352b5e7ba09e57b$var$load("bvY53"),
    $9352b5e7ba09e57b$var$load("ffEVr"),
    $9352b5e7ba09e57b$var$load("219St"),
    $9352b5e7ba09e57b$var$load("b1DMS"),
    $9352b5e7ba09e57b$var$load("eTYdV"),
    $9352b5e7ba09e57b$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("4FVeF"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("4FVeF", function(module, exports) {

let $3677638dc5fdb895$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3677638dc5fdb895$var$load("buoeZ"),
    $3677638dc5fdb895$var$load("h3ABO"),
    $3677638dc5fdb895$var$load("5o4Kn"),
    $3677638dc5fdb895$var$load("6rS39"),
    $3677638dc5fdb895$var$load("kbwlB"),
    $3677638dc5fdb895$var$load("2OkLl"),
    $3677638dc5fdb895$var$load("2YffH"),
    $3677638dc5fdb895$var$load("ly1nW"),
    $3677638dc5fdb895$var$load("bdVyf"),
    $3677638dc5fdb895$var$load("9XOeB"),
    $3677638dc5fdb895$var$load("xu7ej"),
    $3677638dc5fdb895$var$load("iQ4FP"),
    $3677638dc5fdb895$var$load("71gca"),
    $3677638dc5fdb895$var$load("emDJ3"),
    $3677638dc5fdb895$var$load("k3Yy8"),
    $3677638dc5fdb895$var$load("jEvZI"),
    $3677638dc5fdb895$var$load("im1VN"),
    $3677638dc5fdb895$var$load("9yprC"),
    $3677638dc5fdb895$var$load("9anPW"),
    $3677638dc5fdb895$var$load("gWJnq"),
    $3677638dc5fdb895$var$load("i6XKW"),
    $3677638dc5fdb895$var$load("1BN67"),
    $3677638dc5fdb895$var$load("aapZc"),
    $3677638dc5fdb895$var$load("gnDXu"),
    $3677638dc5fdb895$var$load("iqTGf"),
    $3677638dc5fdb895$var$load("3q2Ng"),
    $3677638dc5fdb895$var$load("jRpDi"),
    $3677638dc5fdb895$var$load("jUBhK"),
    $3677638dc5fdb895$var$load("ddJJa"),
    $3677638dc5fdb895$var$load("f6ci5"),
    $3677638dc5fdb895$var$load("lTK3c"),
    $3677638dc5fdb895$var$load("1WXdc"),
    $3677638dc5fdb895$var$load("cFYW8"),
    $3677638dc5fdb895$var$load("lssZe"),
    $3677638dc5fdb895$var$load("b2FtX"),
    $3677638dc5fdb895$var$load("6ocgW"),
    $3677638dc5fdb895$var$load("grkHy"),
    $3677638dc5fdb895$var$load("6iz6l"),
    $3677638dc5fdb895$var$load("4SCW2"),
    $3677638dc5fdb895$var$load("c0JsV"),
    $3677638dc5fdb895$var$load("1OKix"),
    $3677638dc5fdb895$var$load("lVrrs"),
    $3677638dc5fdb895$var$load("3NkiL"),
    $3677638dc5fdb895$var$load("cRtGo"),
    $3677638dc5fdb895$var$load("6wr18"),
    $3677638dc5fdb895$var$load("jvHRs"),
    $3677638dc5fdb895$var$load("2tIxk"),
    $3677638dc5fdb895$var$load("dLq4a"),
    $3677638dc5fdb895$var$load("27glK"),
    $3677638dc5fdb895$var$load("bvY53"),
    $3677638dc5fdb895$var$load("5bjXP"),
    $3677638dc5fdb895$var$load("hhss7"),
    $3677638dc5fdb895$var$load("Wowvf"),
    $3677638dc5fdb895$var$load("ffEVr"),
    $3677638dc5fdb895$var$load("219St"),
    $3677638dc5fdb895$var$load("b1DMS"),
    $3677638dc5fdb895$var$load("jnVKv"),
    $3677638dc5fdb895$var$load("s4822"),
    $3677638dc5fdb895$var$load("7EorR"),
    $3677638dc5fdb895$var$load("bgHzk"),
    $3677638dc5fdb895$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.c1d05e21.js.map
